import { Component, Inject, OnInit } from "@angular/core";
import { HTTPService } from "src/app/services/http.service";
import { threadInfo, threadInfoDetail } from "src/app/interfaces/threadInfo";
import { NZ_MODAL_DATA } from "ng-zorro-antd/modal";
import { WebHookCommonServices } from "../webhook-services/webhook-commom.services";
import { Observable } from "rxjs";

@Component({
    selector: 'webhook-threadlist',
    templateUrl: './webhook-threadlist.component.html',
    styleUrls: ['./webhook-threadlist.component.scss'],
    standalone: false
})

export class WebhookThreadListComponent implements OnInit {
    
    data:Observable<{obs:threadInfoDetail[],loadingThread:boolean}> = new Observable();
    threads:threadInfoDetail[] = [];

    expandSet = new Set<string>();
    onExpandChange(threadName: string, checked: boolean): void {
        if (checked) {
        this.expandSet.add(threadName);
        } else {
        this.expandSet.delete(threadName);
        }
    }

    constructor(
            private http:HTTPService,
            private whcommom:WebHookCommonServices,
            @Inject(NZ_MODAL_DATA) public nzData
    ) { 
        this.data = nzData as Observable<{obs:threadInfoDetail[],loadingThread:boolean}>;
       
    }
    loading = false;
    
    ngOnInit(): void {
        this.data.subscribe((data:{obs:threadInfoDetail[],loadingThread:boolean})=>{
            this.threads = data.obs;
            this.loading = data.loadingThread;
        });
    }

    killThread(item:threadInfoDetail){
        this.loading = true;
        let ob = {
                serverName: item.servername,
                threadName: item.threadName
            }

            this.http.post(ob,'SystemServices/kill',false,true,true).subscribe({
                next:(value)=>{
                    let morto = value['resultado'];
                    if ( morto == 'Morto'){
                        this.whcommom.showSuccessSimple('workflow.success.kill.thread');
                    }else{
                        this.whcommom.showErrorSimple(morto);
                    }
                    this.loading = false;

                },
                error:(error)=>{
                    this.whcommom.showErrorSimple(error);
                    this.loading = false;
                }
            })
    }

}